<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Ano/Série
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-3">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Ano/Série*"
                  counter="25"
                  maxlength="25"
                  outlined
                  dense
                  :rules="[(v) => $required(v), (v) => $max(v, 25)]"
                ></v-text-field>
                <v-textarea
                  v-model="content.descricao"
                  label="O que é esperado do aluno*"
                  counter="2500"
                  maxlength="2500"
                  rows="4"
                  dense
                  outlined
                  :rules="[(v) => $required(v), (v) => $max(v, 2500)]"
                ></v-textarea>
                <v-select
                  v-model="content.modalidade"
                  :items="modalidades"
                  label="Modalidade de Ensino*"
                  outlined
                  dense
                  item-text="nome"
                  return-object
                  :rules="[(v) => $required(v)]"
                ></v-select>
                <v-select
                  v-model="content.quantidadeBimestres"
                  :items="quantidadeBimestres"
                  label="Quantidade de Bimestres*"
                  outlined
                  dense
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
          <div class="mt-4">
            <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
            <span>Os campos marcados com asterisco(*) são obrigatórios.</span>
          </div>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Serie } from '~/commons/classes/serie';
import SerieService from '~/services/serie.service';

export default {
  props: {
    ...new DialogProps(Serie),
    modalidades: {
      type: Array,
      default: () => [],
    },
    quantidadeBimestres: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [SerieService],
  data: () => ({
    form: {
      lists: {
        listPermissoes: [],
      },
    },
  }),
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const serie = new Serie(this.content).format();
          return this.edit
            ? this.$editarSerie(serie, serie.id)
            : this.$cadastrarSerie(serie);
        });
      };
      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
  },
};
</script>
